import {
    getSalesRepPhysician,
    salesRep,
    getAllHospitalByPhysician,
    getAllDept,
    uploadOrgBegin,
    uploadOrgDone,
    downloadResultResource,
    getAllLog,
    addCaseLog,
    exportCustomCaseLog, physician,
    // allHospital
} from '../../../service/service'
import axios from 'axios'

export default {
    name: 'custom',
    data: function () {
        return {
            data2: [],
            total: 0,
            patientName: '',
            dateOfSurgery: '',
            keywordSearch: '',
            columns1: [
                {
                    title: this.$t('Case ID'),
                    minWidth: 140,
                    key: 'id',tooltip:true
                }, {
                    title: this.$t('physician'),
                    minWidth: 140,
                    key: 'physician',tooltip:true
                }, {
                    title: this.$t('specialty'),
                    minWidth: 60,
                    key: 'specialty',tooltip:true
                }, {
                    title: this.$t('patient name'),
                    minWidth: 100,
                    key: 'patientname',tooltip:true
                }, {
                    title: this.$t('hospital'),
                    minWidth: 100,
                    key: 'hospitalName',tooltip:true
                }, {
                    title: this.$t('date of surgery'),
                    minWidth: 100,
                    key: 'dateofsurgery',tooltip:true
                }, {
                    title: this.$t('priority'),
                    minWidth: 60,
                    slot: 'priority',tooltip:true
                }, {
                    title: this.$t('status'),
                    minWidth: 80,
                    key: 'status',tooltip:true
                }, {
                    title: this.$t('surgical plan'),
                    minWidth: 60,
                    slot: 'action',tooltip:true
                }, {
                    title: this.$t('add note'),
                    minWidth: 60,
                    slot: 'action2',tooltip:true
                }, {
                    title: this.$t('more info'),
                    minWidth: 60,
                    slot: 'more'
                }
            ],
            data1: [],
            modal: false,
            txtComment: '',
            formItem: {
                physician: '',
                specialty: '',
                patientname: '',
                hospital: '',
                dateofsurgery: '',
                priority: false,
                representative: ''
            },
            formItem2: {
                physician: '',
                specialty: '',
                patientname: '',
                hospital: '',
                dateofsurgery: '',
                priority: false,
                representative: ''
            },
            note: '',
            ruleInline: {
                physician: [
                    {required: true, message: this.$t('Please select the physician'), trigger: 'change'}
                ],
                representative: [
                    {required: true, message: this.$t('Please select the representative'), trigger: 'change'}
                ],
                patientname: [
                    {required: true, message: this.$t('Please fill in the patient name'), trigger: 'blur'}
                ],
                hospital: [
                    {required: true, message: this.$t('Please select the hospital'), trigger: 'change'}
                ],
                priority: [
                    {required: true, message: this.$t('Please select at priority'), trigger: 'change', type: 'boolean'}
                ]
            },
            modalNext: false,
            fileList: [],
            options: {
                target: axios.defaults.baseURL + 'api/common/uploadOrg',
                testChunks: false,
                // autoStart: false,
                chunkSize: 1024 * 1024 * 2,  //1MB
                simultaneousUploads: 1, //并发上传数
                fileParameterName: 'param',
                query: {
                    caseId: ""
                }
            },
            showConfirmation: false,
            single: false,
            modal3: false,
            modal2: false,
            commentList: [1, 1, 1, 1, 1],
            modal1: false,
            modal6: false,
            showModifyModal: false,
            pagesize: 20,
            pageTo: "1",
            page: 1,
            showBackBtn: true,
            tid: 0,
            tname: '',
            arrTree: [],
            tempTree:[],
            expeditedTotal: 25,
            salesRepresentativeList: [],
            physiciansList: [],
            hospitalList: [],
            hospitalList2: [],
            dataInfo: null,
            specialtylList: [],
            row: {},
            isUpload: false,
            confirmSalesRep: '',
            confirmPhysician: '',
            confirmHospital: '',
            userName: '',
            chooseRow: [{'caseId': 'caseId'}],
            modal7: false,
            tipsCount: '',
            noticStatus: false,
            searchMark: false,
            timeoutId: ''
        }
    },
    methods: {
        ok7() {
            this.modal6 = false
            this.modal = false
            this.modal7 = false
            this.showModifyModal = false
            this.$Spin.show({
                render: (h) => {
                    return h('div', [
                        h('Icon', {
                            'class': 'demo-spin-icon-load',
                            props: {
                                type: 'ios-loading',
                                color: '#f48221',
                                size: 18
                            }
                        }),
                        h('div', {
                            style: {
                                color: '#f48221'
                            },
                        }, 'Loading')
                    ])
                }
            });
            salesRep.custom.getCustomInfo({
                id: this.tid
            }).then(res => {
                let code = parseInt(res.code)
                if (!code) {
                    this.dataInfo = JSON.parse(res.data)
                    console.log(this.dataInfo)
                } else {
                    this.$Message.warning(this.$t('fail'))
                }
                getAllLog({
                    userId: this.token,
                    caseId: this.tid
                }).then(res => {
                    let code = parseInt(res.code)
                    this.$Spin.hide();
                    console.log(JSON.parse(res.data))
                    let logList = []
                    JSON.parse(res.data).forEach(i => {
                        logList.push(JSON.parse(i))
                    })
                    console.log(logList)
                    if (!code) {
                        this.commentList = logList
                    }
                    this.modal2 = true
                })
            })
            this.reloadView()
        },
        toCsv() {
            console.log(JSON.stringify(this.chooseRow))
            exportCustomCaseLog({
                "userId":this.token,
                "patientName": this.patientName,
                "startDateOfSurgery": this.dateOfSurgery[0],
                "endDateOfSurgery": this.dateOfSurgery[1],
                "keywordSearch": this.keywordSearch,
                "physicianList": JSON.stringify(this.arrTree)
            })
        },
        rowClass(row) {
            if (row._isHighlight) {
                // console.log(row)
                return "row-class"
            }
        },
        onSelectRow(row, index) {
            // console.log(this.$refs.tableJin.objData[index])
            // console.log(selection)
            if (!this.$refs.tableJin.objData[index]._isHighlight) {
                this.$refs.tableJin.objData[index]._isHighlight = true
                let obj = {
                    caseId: row.id
                }
                this.chooseRow.push(obj)
            } else {
                this.chooseRow.forEach((e, i) => {
                    if (row.id === e.id) {
                        this.chooseRow.splice(i, 1)
                    }
                })
                this.$refs.tableJin.objData[index]._isHighlight = false
            }
        },
        selectTree(e) {
            this.page = 1
            this.pageTo = 1
            let arr = []
            if (e.length > 0) {
                e.forEach(i => {
                    if (!i.children) {
                        // console.log(i)
                        let obj = {
                            physicianID: i.id
                        }
                        arr.push(obj)
                    }
                });
            } else {
                this.physiciansList.forEach(i => {
                    let obj2 = {
                        physicianID: i.DocId
                    }
                    arr.push(obj2)
                })
            }
            this.arrTree = arr
            this.reloadView()
        },
        reloadView() {
            let obj = {
                "userId": this.token,
                "page": this.page,
                "limit": this.pagesize,
                "patientName": this.patientName,
                "startDateOfSurgery": this.dateOfSurgery[0],
                "endDateOfSurgery": this.dateOfSurgery[1],
                "keywordSearch": this.keywordSearch,
                "physicianList": JSON.stringify(this.arrTree)
            }
            salesRep.custom.getCustomData(obj).then(res => {
                let code = parseInt(res.code)
                this.$Spin.hide();
                if (!code) {
                    let data = JSON.parse(res.data)
                    console.log(data)
                    if (data.list) {
                        this.data1 = JSON.parse(data.list)
                        console.log(this.data1)
                    } else {
                        this.data1 = []
                    }
                    // console.log(JSON.parse(data.list))
                    this.total = data.totalAll
                    this.expeditedTotal = data.totalExpedited
                    this.$refs.elScrol.wrap.scrollTop = 0
                    this.$refs.elScrol.wrap.scrollLeft = 0
                }
            })
        },
        goPage() {
            if (this.pageTo) {
                let maxPage = Math.ceil(parseInt(this.total) / parseInt(this.pagesize))
                if (parseInt(this.pageTo) > maxPage) {
                    this.page = maxPage
                } else {
                    this.page = parseInt(this.pageTo)
                }
                this.pageTo = this.page
                this.reloadView()
            } else {
                this.pageTo = this.page
            }
        },
        changePage(e) {
            // console.log(e)
            this.page = e
            this.pageTo = e
            this.reloadView()
        },
        changePageSize(size) {
            this.page = 1
            this.pageTo = 1
            this.pagesize = size
            this.reloadView()
        },
        changePatientName() {
            var that = this;
            if (this.searchMark) {
                clearTimeout(this.timeoutId);
                this.timeoutId = setTimeout(function () {
                    that.page  = 1;
                    that.reloadView();
                }, 1000);
            } else {
                this.timeoutId = setTimeout(function () {
                    that.page  = 1;
                    that.reloadView();
                }, 1000);
                this.searchMark = true;
            }
        },
        ok6() {
            if (this.txtComment.length > 60000) {
                this.$Message.error('Comment should be no longer than 60,000 characters.')
                return;
            }
            var that = this;
            let userName = sessionStorage.getItem('userName')
            let obj = {
                id: this.tid,
                count: this.txtComment,
                userid: this.token,
                currentUserName: userName
            }
            salesRep.custom.customRequestCancellation(obj).then(res => {
                console.log(res)
                if (res.code === '0') {
                    this.modal7 = true
                    addCaseLog({
                        userId: this.token,
                        caseId: this.tid,
                        logType: 'Case Cancelled',
                        remarks: that.txtComment
                    }).then(res => {
                        console.log(res)
                        this.txtComment = ''
                    })
                } else if (res.code === '-100') {
                    this.$Message.error('No permission to perform this operation.')
                } else {
                    this.$Message.warning(this.$t('fail'))
                }
            })
        },
        cancel6() {
            this.modal6 = false
        },
        requestCancellation() {
            this.modal6 = true
        },
        ok5() {
            if (this.note.length > 60000) {
                this.$Message.error('Comment should be no longer than 60,000 characters.')
                return;
            }
            let p = {
                "userId": this.token,
                "salesRepresentative": this.dataInfo.SalesId,
                "id": this.tid,
                "physician": this.formItem2.physician,
                "patientName": this.formItem2.patientname,
                "hospital": this.formItem2.hospital,
                "dateOfSurgery": this.formItem2.dateofsurgery,
                "notes": this.note
                // "flieList": JSON.stringify(this.fileList)
            }
            if (this.dataInfo.CaseUrgent === 'expedited') {
                p.priority = 'Expedited'
            } else {
                p.priority = 'Standard'
            }
            this.$Spin.show({
                render: (h) => {
                    return h('div', [
                        h('Icon', {
                            'class': 'demo-spin-icon-load',
                            props: {
                                type: 'ios-loading',
                                color: '#f48221',
                                size: 18
                            }
                        }),
                        h('div', {
                            style: {
                                color: '#f48221'
                            },
                        }, 'Loading')
                    ])
                }
            });
            salesRep.custom.editCustomInfo(p).then(res => {
                this.$Spin.hide();
                if (res.code === '0') {
                    this.modal = false
                    this.modalNext = false
                    this.note = ''
                    this.formItem2.physician = ''
                    this.formItem2.specialty = ''
                    this.formItem2.patientname = ''
                    this.formItem2.hospital = ''
                    this.formItem2.dateofsurgery = ''
                    this.formItem2.priority = false
                    this.showConfirmation = false
                    // this.modal3 = true
                    // this.$Message.success(this.$t('success'))
                    this.modal6 = false
                    // this.modal2 = false
                    salesRep.custom.getCustomInfo({
                        id: this.tid
                    }).then(res => {
                        let code = parseInt(res.code)
                        if (!code) {
                            this.dataInfo = JSON.parse(res.data)
                            console.log(this.dataInfo)
                        } else {
                            this.$Message.warning(this.$t('fail'))
                        }
                        getAllLog({
                            userId: this.token,
                            caseId: this.tid
                        }).then(res => {
                            this.showModifyModal = false
                            let code = parseInt(res.code)
                            this.$Spin.hide();
                            console.log(JSON.parse(res.data))
                            let logList = []
                            JSON.parse(res.data).forEach(i => {
                                logList.push(JSON.parse(i))
                            })
                            console.log(logList)
                            if (!code) {
                                this.commentList = logList
                            }
                            this.modal2 = true
                        })
                    })
                } else if (res.code === '-100') {
                    this.$Message.error('No permission to perform this operation.')
                } else {
                    this.$Message.warning(this.$t('fail'))
                }
            })
        },
        cancel5() {
            // this.modal2 = false
            this.showModifyModal = false
            this.formItem2.physician = ''
            this.formItem2.hospital = ''
            this.formItem2.patientname = ''
            this.formItem2.dateofsurgery = ''
            this.note = ''
        },
        showModify() {
            console.log(this.dataInfo)
            this.formItem2.physician = this.dataInfo.DocId
            console.log(this.hospitalList)
            // this.hospitalList.forEach(i=>{
            //     if(i.hospitalId === )
            // })
            this.formItem2.hospital = this.dataInfo.CaseHos
            this.formItem2.patientname = this.dataInfo.CasePatient
            this.formItem2.dateofsurgery = this.dataInfo.CaseSurgdate
            this.showModifyModal = true
            getAllHospitalByPhysician({
                userId: this.token,
                doctorId: this.dataInfo.DocId
            }).then(res => {
                let code = parseInt(res.code)
                if (!code) {
                    let hosList = JSON.parse(res.data)
                    console.log(hosList)
                    this.hospitalList2 = hosList
                }
            })
        },
        ok4() {
            if (this.txtComment.length > 60000) {
                this.$Message.error('Comment should be no longer than 60,000 characters.')
                return;
            }
            // let obj = {
            //     "userId": this.token,
            //     "id": this.tid,
            //     "name": this.userName,
            //     "count": this.txtComment
            // }
            this.$Spin.show({
                render: (h) => {
                    return h('div', [
                        h('Icon', {
                            'class': 'demo-spin-icon-load',
                            props: {
                                type: 'ios-loading',
                                color: '#f48221',
                                size: 18
                            }
                        }),
                        h('div', {
                            style: {
                                color: '#f48221'
                            },
                        }, 'Loading')
                    ])
                }
            });
            salesRep.custom.addCustomComment({
                userId:this.token,
                id:this.tid,
                count:this.txtComment
            }).then(res=>{
                console.log(res)
                this.$Spin.hide();
                let code = parseInt(res.code)
                if(!code){
                    this.modal1 = false
                    this.txtComment = ''
                    this.tname = ''
                    getAllLog({
                        userId:this.token,
                        caseId: this.tid
                    }).then(res=>{
                        let code = parseInt(res.code)
                        this.$Spin.hide();
                        console.log(JSON.parse(res.data))
                        let logList = []
                        JSON.parse(res.data).forEach(i=>{
                            logList.push(JSON.parse(i))
                        })
                        console.log(logList)
                        if(!code){
                            this.commentList = logList
                        }
                        if (this.showModifyModal){
                            this.modal2 = true
                        }
                    })
                }else{
                    this.$Message.warning(this.$t('fail'))
                }
            })
            // salesRep.custom.addCustomComment(obj).then(res=>{
            //     console.log(res)
            //     let code = parseInt(res.code)
            //     if(!code){
            //         this.modal1 = false
            //         this.txtComment = ''
            //         this.tname = ''

            //     }else{
            //         this.$Message.warning(this.$t('fail'))
            //     }
            // })
        },
        cancel4() {
            this.modal1 = false
        },
        addComment2() {
            this.modal1 = true
        },
        addComment(row, index) {
            console.log(row, index)
            this.tid = row.id
            this.tname = row.name
            this.modal1 = true
        },
        showDetail(row) {
            this.row = row
            this.tid = row.id
            // this.options.query.caseId = row.id
            this.tname = row.name
            let p = {
                id: this.tid
            }
            this.$Spin.show({
                render: (h) => {
                    return h('div', [
                        h('Icon', {
                            'class': 'demo-spin-icon-load',
                            props: {
                                type: 'ios-loading',
                                color: '#f48221',
                                size: 18
                            }
                        }),
                        h('div', {
                            style: {
                                color: '#f48221'
                            },
                        }, 'Loading')
                    ])
                }
            });
            salesRep.custom.getCustomInfo(p).then(res => {
                let code = parseInt(res.code)
                if (!code) {
                    this.dataInfo = JSON.parse(res.data)
                    console.log(this.dataInfo)
                    this.options.query.caseId = this.dataInfo.CaseId
                }
                getAllLog({
                    userId: this.token,
                    caseId: this.tid
                }).then(res => {
                    let code = parseInt(res.code)
                    this.$Spin.hide();
                    console.log(JSON.parse(res.data))
                    let logList = []
                    JSON.parse(res.data).forEach(i => {
                        logList.push(JSON.parse(i))
                    })
                    console.log(logList)
                    if (!code) {
                        this.commentList = logList
                    }
                    if (!this.showModifyModal){
                        this.modal2 = true
                    }
                })
            })
        },
        ok3() {
            this.modal3 = false
            this.fileList = []
            this.modalNext = false
            this.reloadView()
        },
        fileAdded(file) {
            console.log(file)
            uploadOrgDone({caseId: this.options.query.caseId}).then(res => {
                if (res.code === '0') {
                    // this.modalNext = true
                    if (this.showModifyModal) {
                        this.isUpload = false
                        addCaseLog({
                            userId: this.token,
                            caseId: this.tid,
                            logType: 'Additional Data Uploaded',
                            remarks: ''
                        }).then(res => {
                            console.log(res)
                            if (this.noticStatus) {
                                let userName = sessionStorage.getItem('userName')
                                salesRep.custom.uploadNewFileNotice({
                                    id: this.options.query.caseId,
                                    currentUserName: userName
                                }).then(() => {
                                    this.noticStatus = false
                                })
                            }
                        })
                    }
                    this.modal = false
                    this.modalNext = false
                    this.note = ''
                    this.formItem.physician = ''
                    this.formItem.specialty = ''
                    this.formItem.patientname = ''
                    this.formItem.hospital = ''
                    this.formItem.dateofsurgery = ''
                    this.formItem.priority = false
                    this.showConfirmation = false
                    this.modal3 = true
                    this.modal6 = false
                    this.$Spin.hide();
                }
            })
        },
        delFile(i) {
            this.fileList.splice(i, 1)
        },
        handleUpload(file) {
            // this.isUpload = true
            console.log(file)
            let arr = this.fileList;
            arr.push(file)
            this.fileList = arr
            return false;
        },
        back() {
            this.modalNext = false
        },
        handleSubmit(name) {
            // this.$Spin.show();
            this.$refs[name].validate((valid) => {
                if (valid) {
                    // this.$Message.success('Success!');
                    this.modalNext = true
                } else {
                    this.$Message.error('Please ﬁx the error(s) indicated below.');
                }
            })
        },
        ok1() {
            // this.modal = false
            // this.modalNext = false
            // this.note = ''
            // this.formItem.physician = ''
            // this.formItem.specialty = ''
            // this.formItem.patientname = ''
            // this.formItem.hospital = ''
            // this.formItem.dateofsurgery = ''
            // this.formItem.priority = false
            // this.showConfirmation = false
            // this.modal3 = true
            // this.modal6 = false
            if (this.note.length > 60000) {
                this.$Message.error('Comment should be no longer than 60,000 characters.')
                return;
            }
            this.single  = false;
            this.$Spin.show({
                render: (h) => {
                    return h('div', [
                        h('Icon', {
                            'class': 'demo-spin-icon-load',
                            props: {
                                type: 'ios-loading',
                                color: '#f48221',
                                size: 18
                            }
                        }),
                        h('div', {
                            style: {
                                color: '#f48221'
                            },
                        }, 'Uploading')
                    ])
                }
            });
            let p = {
                "userId": this.token,
                "salesRepresentative": this.token,
                "physician": this.formItem.physician,
                "patientName": this.formItem.patientname,
                "hospital": this.formItem.hospital,
                "dateOfSurgery": this.formItem.dateofsurgery,
                // "priority": this.formItem.priority,
                "notes": this.note,
                // "flieList": JSON.stringify(this.fileList)
                // "flieList": JSON.stringify(this.fileList)
            }
            if (this.formItem.priority) {
                p.priority = 'Expedited'
            } else {
                p.priority = 'Standard'
            }
            salesRep.custom.addNewCase(p).then(res => {
                console.log(res)
                let code = parseInt(res.code)
                if (!code) {
                    addCaseLog({
                        userId: this.token,
                        caseId: this.tid,
                        logType: 'Case Submitted',
                        remarks: this.note
                    }).then(res => {
                        console.log(res)
                    })
                    this.options.query.caseId = res.caseId
                    this.tipsCount = 'A new case has been created.'
                    uploadOrgBegin({caseId: res.caseId}).then(res => {
                        if (res.code === '0') {
                            let uploaderInstance = this.$refs.uploader.uploader
                            uploaderInstance.resume()
                        } else {
                            this.$Message.warning(this.$t('fail'))
                        }
                        // this.$Spin.hide();
                    })
                } else if (res.code === '-100') {
                    this.$Message.error('No permission to perform this operation.')
                } else {
                    this.$Message.warning(this.$t('fail'))
                }
            })
        },
        ok() {
            if (!this.showModifyModal) {
                this.showConfirmation = true
                // const uploaderInstance = this.$refs.uploader.uploader
                // console.log(uploaderInstance.upload)
            } else {
                let uploaderInstance = this.$refs.uploader.uploader
                uploaderInstance.resume()
                this.$Spin.show({
                    render: (h) => {
                        return h('div', [
                            h('Icon', {
                                'class': 'demo-spin-icon-load',
                                props: {
                                    type: 'ios-loading',
                                    color: '#f48221',
                                    size: 18
                                }
                            }),
                            h('div', {
                                style: {
                                    color: '#f48221'
                                },
                            }, 'Uploading')
                        ])
                    }
                });
                this.isUpload = true
                // this.modal = false
            }
        },
        cancel1() {
            this.showConfirmation = false
        },
        onModalCancel() {
            if (!this.showModifyModal) {
                this.formItem.physician = ''
                this.formItem.specialty = ''
                this.formItem.patientname = ''
                this.formItem.hospital = ''
                this.formItem.dateofsurgery = ''
                this.formItem.priority = false
            }
            if (this.modalNext) {
                let uploaderInstance = this.$refs.uploader.uploader
                uploaderInstance.cancel()
            }
            this.fileList = []
            this.modal = false
            this.modalNext = false
        },
        cancel() {
            if (!this.showModifyModal) {
                this.formItem.physician = ''
                this.formItem.specialty = ''
                this.formItem.patientname = ''
                this.formItem.hospital = ''
                this.formItem.dateofsurgery = ''
                this.formItem.priority = false
            }
            if (this.modalNext) {
                let uploaderInstance = this.$refs.uploader.uploader
                uploaderInstance.cancel()
            }
            this.fileList = []
            this.modal = false
            this.modalNext = false
        },
        addCase2() {
            this.options.query.caseId = this.dataInfo.CaseId
            // console.log(this.options.query.caseId)
            this.tipsCount = 'Additional DICOM files have been uploaded.'
            this.noticStatus = true
            uploadOrgBegin({caseId: this.dataInfo.CaseId}).then(res => {
                if (res.code === '0') {
                    // this.$Message.success('Success!');
                    this.showBackBtn = false
                    this.modalNext = true
                    this.modal = true
                } else if (res.code === '-100') {
                    this.$Message.error('No permission to perform this operation.')
                } else {
                    this.$Message.warning(this.$t('fail'))
                }
                this.$Spin.hide();
            })
        },
        addCase() {
            this.modal = true
            this.showBackBtn = true
        },
        download(row) {
            if (row.resultId === undefined || row.resultId === '') {
                this.$Message.error('The surgical plan is unavailable')
                return;
            } else {
                downloadResultResource({caseId: row.id})
            }
        },
        showDate() {
            var that = this;
            if (this.searchMark) {
                clearTimeout(this.timeoutId);
                this.timeoutId = setTimeout(function () {
                    that.page = 1;
                    that.reloadView();
                }, 2000);
            } else {
                this.timeoutId = setTimeout(function () {
                    that.page = 1;
                    that.reloadView();
                }, 2000);
                this.searchMark = true;
            }
        },
        dateChange2(e) {
            this.formItem2.dateofsurgery = e
        },
        dateChange1(e) {
            this.formItem.dateofsurgery = e
        },
        dateChange(e) {
            this.dateOfSurgery = e
            var that = this;
            if (this.searchMark) {
                clearTimeout(this.timeoutId);
                this.timeoutId = setTimeout(function () {
                    that.page  = 1;
                    that.reloadView();
                }, 1000);
            } else {
                this.timeoutId = setTimeout(function () {
                    that.page  = 1;
                    that.reloadView();
                }, 1000);
                this.searchMark = true;
            }
        },
        selectSales(e) {
            if (e !== undefined) {
                this.confirmSalesRep = e.label
            }
        },
        selectPhysician(e) {
            if (e !== undefined) {
                console.log(e)
                this.confirmPhysician = e.label
                this.formItem.hospital = ''
                this.formItem2.hospital = ''
                getAllHospitalByPhysician({userId: this.token, doctorId: e.value}).then(res => {
                    let code = parseInt(res.code)
                    if (!code) {
                        let hosList = JSON.parse(res.data)
                        console.log(hosList)
                        this.hospitalList2 = hosList
                    }
                })
            }
        },
        selectHospital(e) {
            if (e !== undefined) {
                this.confirmHospital = e.label
            }
        }
    },
    created() {

    },
    mounted() {
        this.userName = sessionStorage.getItem('userName')
        this.token = sessionStorage.getItem('token') || sessionStorage.getItem('token')
        // console.log(token)
        this.$Spin.show({
            render: (h) => {
                return h('div', [
                    h('Icon', {
                        'class': 'demo-spin-icon-load',
                        props: {
                            type: 'ios-loading',
                            color: '#f48221',
                            size: 18
                        }
                    }),
                    h('div', {
                        style: {
                            color: '#f48221'
                        },
                    }, 'Loading')
                ])
            }
        });
        // eslint-disable-next-line no-irregular-whitespace
        let h = document.body.clientWidth
        // eslint-disable-next-line no-irregular-whitespace
        document.querySelectorAll('.custom-modal-details').forEach(i => {
            // eslint-disable-next-line no-irregular-whitespace
            i.style.zoom = h / 1920 * 100 + '%'
        })
        // eslint-disable-next-line no-irregular-whitespace
        document.querySelectorAll('.custom-modal-case').forEach(i => {
            // eslint-disable-next-line no-irregular-whitespace
            i.style.zoom = h / 1920 * 100 + '%'
        })
        // eslint-disable-next-line no-irregular-whitespace
        document.querySelectorAll('.custom-modal').forEach(i => {
            // eslint-disable-next-line no-irregular-whitespace
            i.style.zoom = h / 1920 * 100 + '%'
        })
        // eslint-disable-next-line no-irregular-whitespace
        document.querySelectorAll('.custom-modal2').forEach(i => {
            // eslint-disable-next-line no-irregular-whitespace
            i.style.zoom = h / 1920 * 100 + '%'
        })
        // eslint-disable-next-line no-irregular-whitespace
        document.querySelectorAll('.custom-modal1').forEach(i => {
            // eslint-disable-next-line no-irregular-whitespace
            i.style.zoom = h / 1920 * 100 + '%'
        })
        // eslint-disable-next-line no-irregular-whitespace
        window.onresize = function () {
            // eslint-disable-next-line no-irregular-whitespace
            document.querySelectorAll('.custom-modal').forEach(i => {
                // eslint-disable-next-line no-irregular-whitespace
                i.style.zoom = h / 1920 * 100 + '%'
            })
            // eslint-disable-next-line no-irregular-whitespace
            // console.log(h/1920 * 100 + '%')
            document.querySelectorAll('.custom-modal-details').forEach(i => {
                // eslint-disable-next-line no-irregular-whitespace
                i.style.zoom = h / 1920 * 100 + '%'
            })
            // eslint-disable-next-line no-irregular-whitespace
            document.querySelectorAll('.custom-modal-case').forEach(i => {
                // eslint-disable-next-line no-irregular-whitespace
                i.style.zoom = h / 1920 * 100 + '%'
            })
            // eslint-disable-next-line no-irregular-whitespace
            document.querySelectorAll('.custom-modal2').forEach(i => {
                // eslint-disable-next-line no-irregular-whitespace
                i.style.zoom = h / 1920 * 100 + '%'
            })
            // eslint-disable-next-line no-irregular-whitespace
            document.querySelectorAll('.custom-modal1').forEach(i => {
                // eslint-disable-next-line no-irregular-whitespace
                i.style.zoom = h / 1920 * 100 + '%'
            })
        }
        getAllDept({UserUID: this.token}).then(res => {
            this.specialtylList = res.Dept
        })
        this.$Spin.hide();
        let arr = [{
            title: 'All Physicians',
            id: 0,
            children: [],
            expand: true
        }]
        let arr2 = []
        getSalesRepPhysician({UserUID: this.token}).then(res => {
            console.log(res)
            this.physiciansList = res.Physician
            res.Physician.forEach(i => {
                let obj = {
                    title: i.DocName,
                    id: i.DocId,
                    expand: true
                }
                let obj2 = {
                    physicianID: i.DocId
                }
                arr[0].children.push(obj)
                arr2.push(obj2)
            })

            this.data2 = arr
            this.arrTree = arr2
            // this.isSelectTree = true
            this.reloadView()
        })
    }
}
